<template>
  <div class="fd">

  
  <div class="footer tabbar row" style="z-index: 5">
    
    <a :class="['cc', {'active': homeActive}]" @click="toHome">
      <i class="iconfont icon-1"></i>
      <span>漫画频道</span>
    </a>
    
    <a :class="['cc', {'active': vodActive}]" @click="toVod">
      <i class="iconfont icon-3"></i>
      <span>高清视频</span>
    </a>

    <a :class="['cc', {'active': novelActive}]" @click="toNovel">
      <i class="iconfont icon-8"></i>
      <span>小说书城</span>
    </a>

    <a :class="['cc', {'active': purchaseActive}]" @click="toPurchase">
      <i class="iconfont icon-11"></i>
      <span>充值</span>
    </a>

    <a :class="['cc', {'active': userActive}]" @click="toMine">
      <i class="iconfont icon-5"></i>
      <span>个人中心</span>
    </a>
  </div>

</div>

</template>

<script>

  export default {
    name: "layer1",
    computed: {
      homeActive() {
        return this.$route.name === 'home'
      },
      novelActive() {
        return this.$route.path === '/novel'
      },
      vodActive() {
        return this.$route.path === '/vod'
      },
      userActive() {
        return this.$route.path === '/user'
      },
      purchaseActive() {
        return this.$route.path === '/purchase'
      },
      
    },
    methods: {
      toHome() {
        if (this.$route.name === 'home') return;
        this.$router.isBack = false;
        this.$router.push('/home')
        // this.$emit('page-change', 'home')
      },
      toCategory() {
        if (this.$route.name === 'category') return;
        this.$router.isBack = false;
        this.$router.push('/category')
        // this.$emit('page-change', 'category')
      },
      toVod() {
        if (this.$route.name === 'vod') return;
        this.$router.isBack = false;
        this.$router.push('/vod')
        // this.$emit('page-change', 'vod')
      },

      toNovel() {
        if (this.$route.name === 'novel') return;
        this.$router.isBack = false;
        this.$router.push('/novel')
      },

      toNew() {
        if (this.$route.name === 'new') return;
        this.$router.isBack = false;
        this.$router.push('/home/new')
      },
      toHistory() {
        if (this.$route.name === 'shelf') return;
        this.$router.isBack = false;
        this.$router.push('/shelf')
        // this.$emit('page-change', 'shelf')
      },
      toMine() {
        if (this.$route.name === 'user') return;
        this.$router.isBack = false;
        this.$router.push('/user')
        // this.$emit('page-change', 'user')
      },
      toPurchase() {
        if (this.$route.name === 'purchase') return;
        this.$router.isBack = false;
        this.$router.push('/purchase')
      },
    }
  }
</script>

<style scoped>
  /*
  a.active {
    background-color: #f0f0f0;
  }
  a.active span {
    color: #000000;
  }
   */
</style>



// WEBPACK FOOTER //
// src/components/layer1/bottomIndex.vue